import request from "./request";
const api = {
    getSignature: "/v2/mp/jsapi/signature?url=" + encodeURIComponent(window.location.href)
}
export function getSign() {
    return request(api.getSignature, null, {
        method: "get",
        headers: { "content-type": "application/json" }
    });
}